import { Controller } from 'react-hook-form'
import { FormControl, FormErrorMessage, FormLabel, HStack } from '@chakra-ui/react'
import { PropsValue, Select } from 'chakra-react-select'

import { useEventFormOptions } from '@hooks/useEventFormOptions'

import { MatchEventEditorEventType } from '@common/types'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

import { type Option } from '../utils'

export function ReviewDetailsSelectorGroup() {
    const { zodForm, isFormDisabled } = useMatchEditorFormContext()

    const { varOverReview } = useEventFormOptions()

    const selectedEventType = zodForm.watch('type.value')

    if (Number(selectedEventType) !== MatchEventEditorEventType.video_assistant_referee_over || !varOverReview) {
        return null
    }

    return (
        <HStack mb={8} alignItems="flex-start">
            <Controller
                control={zodForm.control}
                name="review_original_decision"
                render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                    <FormControl isInvalid={!!error} isDisabled={isFormDisabled} isRequired>
                        <FormLabel htmlFor="type">Original Decision</FormLabel>
                        <Select
                            id="type"
                            isSearchable
                            name={name}
                            ref={ref}
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value as unknown as PropsValue<Option>}
                            placeholder="Select original decision"
                            options={varOverReview}
                        />

                        <FormErrorMessage>{zodForm.formState.errors.type?.message}</FormErrorMessage>
                    </FormControl>
                )}
            />
            <Controller
                control={zodForm.control}
                name="review_outcome"
                render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                    <FormControl isInvalid={!!error} isDisabled={isFormDisabled} isRequired>
                        <FormLabel htmlFor="type">Review Outcome</FormLabel>
                        <Select
                            id="type"
                            isSearchable
                            name={name}
                            ref={ref}
                            onChange={v => {
                                // reset player fields as current selection, if any, become invalid
                                zodForm.setValue('extra_info', Number(v?.value), { shouldDirty: false })

                                onChange(v)
                            }}
                            onBlur={onBlur}
                            value={value as unknown as PropsValue<Option>}
                            placeholder="Select review outcome"
                            options={varOverReview}
                        />

                        <FormErrorMessage>{zodForm.formState.errors.type?.message}</FormErrorMessage>
                    </FormControl>
                )}
            />
        </HStack>
    )
}
